module.exports = __webpack_public_path__ + "img/abr.4e1bf13.svg";